class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimer = null;

    if (!HeaderMenu.pointer) {
      HeaderMenu.pointer = { x: 0, y: 0 };
      window.addEventListener(
        'pointermove',
        (event) => {
          HeaderMenu.pointer = { x: event.clientX, y: event.clientY };
          HeaderMenu.closeMenusOutsideSafeArea();
        },
        { passive: true }
      );
    }

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHover.bind(this));
    this.summary.addEventListener('click', this.navigateOnDesktopClick.bind(this));
    this.content.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.content.addEventListener('mouseleave', this.closeOnHover.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    window.clearTimeout(this.closeTimer);
    this.closeOtherMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      if (!this.isPointerInSafeArea()) this.close();
    }, 80);
  }

  navigateOnDesktopClick(event) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const url = this.summary.dataset.menuUrl;
    if (!url || url === '#') return;
    event.preventDefault();
    window.location.href = url;
  }

  closeOtherMenus() {
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });
  }

  isPointerInSafeArea() {
    if (this.matches(':hover') || this.content.matches(':hover')) return true;

    const pointer = HeaderMenu.pointer;
    const summaryRect = this.summary.getBoundingClientRect();
    const contentRect = this.content.getBoundingClientRect();
    const isBetweenTriggerAndPanel =
      pointer.y >= summaryRect.bottom &&
      pointer.y <= contentRect.top + 8 &&
      pointer.x >= contentRect.left &&
      pointer.x <= contentRect.right;

    return isBetweenTriggerAndPanel;
  }

  static closeMenusOutsideSafeArea() {
    window.cancelAnimationFrame(HeaderMenu.closeFrame);
    HeaderMenu.closeFrame = window.requestAnimationFrame(() => {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu.mainDetailsToggle?.open && !menu.isPointerInSafeArea()) menu.close();
      });
    });
  }
}

customElements.define('header-menu', HeaderMenu);
